<div class="col-12 px-0 my-4">
  <p class="page-header">Detailed trade history</p>
</div>

<div class="d-flex mx-auto chart">
  <ngx-charts-bar-vertical-stacked [scheme]="colorScheme" [results]="chartData" [legend]="false" [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel" [showXAxisLabel]="true" [showYAxisLabel]="showYAxisLabel" [xAxis]="true" [yAxis]="true" [roundDomains]="false"
    [rotateXAxisTicks]="0" [barPadding]="barPadding" (select)="getAllTradesByMonth($event)">

    <ng-template #tooltipTemplate let-model="model">
      <div *ngIf="model.value > 0" class="{{model.extra.class}}">
        <div>Total = {{model.value}}</div>
        <div *ngIf="model.extra.gbp > 0">GBP = {{ model.extra.gbp }}</div>
        <div *ngIf="model.extra.eur > 0">EUR = {{ model.extra.eur }}</div>
        <div *ngIf="model.extra.usd > 0">USD = {{ model.extra.usd }}</div>
        <div *ngIf="model.extra.other > 0">Others = {{ model.extra.other }}</div>
      </div>
    </ng-template>
  </ngx-charts-bar-vertical-stacked>
</div>


<div class="d-flex justify-content-center">
  <div class="left-note note d-flex align-items-center">
    <div class="circle"></div>
    <div class="text">Settled</div>
  </div>
  <div class="note d-flex align-items-center">
    <div class="circle"></div>
    <div class="text">Outstanding</div>
  </div>
</div>
<br>
<div class="col-12 px-0 my-4">
  <p class="page-header">Search for specific payments by:</p>
</div>
<form [formGroup]="searchForm">
  <div class="row px-md-4">
    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <input matInput [matDatepicker]="fromDate" formControlName="fromDate" (click)="togglePicker(fromDate)" placeholder="Date from"
        />
        <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #fromDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <input matInput [matDatepicker]="toDate" formControlName="toDate" (click)="togglePicker(toDate)" placeholder="Date to" />
        <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #toDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-2 form-group">
      <mat-form-field>
        <mat-select formControlName="buyCurrency" placeholder="Buy currency">
          <mat-select-trigger>
            <ng-container *ngIf="!searchForm.get('buyCurrency').value; else: showBuyCurrency">
              All
            </ng-container>
            <ng-template #showBuyCurrency>
              <div [innerHTML]="searchForm.get('buyCurrency').value | transformCurrency : currencies"></div>
            </ng-template>
          </mat-select-trigger>
          <mat-option [value]="0">All</mat-option>
          <mat-option *ngFor="let currency of currencies" [value]="currency.id">
            <span [class]="currency.code | flagIcon"></span>&nbsp;
            <span>{{ currency.code }} </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-2 form-group">
      <mat-form-field>
        <input matInput npInputMask [options]="{
                        numeral: true,
                        numeralIntegerScale: 255
                      }" formControlName="buyAmount" placeholder="Buy amount" />
      </mat-form-field>
    </div>
  </div>

  <div class="row px-md-4">
    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <mat-select formControlName="tradeStatus" placeholder="Trade status">
          <mat-option [value]="0">All</mat-option>
          <mat-option *ngFor="let item of tradeStatus" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <input matInput [matDatepicker]="openDate" formControlName="openDate" (click)="togglePicker(openDate)" placeholder="Open date"
        />
        <mat-datepicker-toggle matSuffix [for]="openDate"></mat-datepicker-toggle>
        <mat-datepicker panelClass="greengo" #openDate></mat-datepicker>
      </mat-form-field>
    </div>


    <div class="col-12 col-lg-2 form-group">
      <mat-form-field>
        <mat-select formControlName="sellCurrency" placeholder="Sell currency">
          <mat-select-trigger>
            <ng-container *ngIf="!searchForm.get('sellCurrency').value; else: showSellCurrency">
              All
            </ng-container>
            <ng-template #showSellCurrency>
              <div [innerHTML]="searchForm.get('sellCurrency').value | transformCurrency : currencies"></div>
            </ng-template>
          </mat-select-trigger>
          <mat-option [value]="0">All</mat-option>
          <mat-option *ngFor="let currency of currencies" [value]="currency.id">
            <span [class]="currency.code | flagIcon"></span>&nbsp;
            <span>{{ currency.code }} </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-2 form-group">
      <mat-form-field>
        <input matInput npInputMask [options]="{
                          numeral: true,
                          numeralIntegerScale: 255
                        }" formControlName="sellAmount" type="text" placeholder="Sell amount" />
      </mat-form-field>
    </div>


  </div>

  <div class="row px-md-4">
    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <input matInput formControlName="tradeReference" placeholder="Trade reference" />
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-4 form-group">
      <mat-form-field>
        <mat-select formControlName="tradeType" placeholder="Trade type">
          <mat-option [value]="0">All</mat-option>
          <mat-option *ngFor="let item of tradeTypes" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-2 form-group">
      <mat-form-field>
        <input matInput npInputMask [options]="{
                      numeral: true,
                      numeralIntegerScale: 255
                    }" formControlName="rate" placeholder="Rate" />
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-2 form-group">
      <button class="btn btn-lg btn-block btn-greengo" (click)="getSearchData()" npFocusOutClicked>Search</button>
    </div>
  </div>
</form>

<div class="d-flex col-12 px-0 px-md-4 table-title my-2">
  <div class="ml-auto">
    <div class="d-flex filter-column-trade align-items-center" (click)="showFilter = !showFilter">
      <span>Filter</span>
      <div class="img ml-auto">
        <img class="icon-info ml-auto" src="./assets/images/icon-png/icon-info-dark.svg" alt="" />
        <span class="send-payment-tooltip tooltip-left">Drag and drop your
          <br> preferred items into either
          <br> the Visible or Hidden boxes
          <br> and click Confirm to view
          <br> your customised selection.</span>
      </div>
    </div>
  </div>
</div>

<div class="d-flex drag-drop-box" *ngIf="showFilter">
  <div class="col-md-6">
    <div class="drag-container">
      <div class="section-heading">Visible columns</div>
      <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="todo" [cdkDropListConnectedTo]="[doneList]" class="item-list"
        (cdkDropListDropped)="drop($event)">
        <div class="item-box" *ngFor="let item of todo" cdkDrag>{{ item }}</div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="drag-container">
      <div class="section-heading">Hidden columns</div>
      <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done" [cdkDropListConnectedTo]="[pendingList]" class="item-list"
        (cdkDropListDropped)="drop($event)">
        <div class="item-box" *ngFor="let item of done" cdkDrag>{{ item }}</div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-3 ml-auto">
        <button class="btn btn-block btn-lg btn-greengo" (click)="reOrder()" npFocusOutClicked>
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="!isLoading">
  <div class="col-12 px-0 px-md-4 trade-history-table">
    <ng-table [rows]="rows" [columns]="columns" (cellClicked)="onCellClick($event)">
    </ng-table>
  </div>

  <div class="d-flex justify-content-end col-12 px-0 px-md-4">
    <button *ngIf="showDownloadConsolidated" class="btn btn-block btn-lg btn-greengo col-md-2 m-2" (click)="downloadExcel(true)" npFocusOutClicked>Download consolidated report</button>
    <button class="btn btn-block btn-lg btn-greengo col-md-2 my-2" (click)="downloadExcel(false)" npFocusOutClicked>Download</button>
  </div>
</ng-container>
